import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------ *\
  #TABS
\* ------------------------------------ */
/**
 * Component typography presets
 */
.cat-c-tabs--full-width ::slotted(cat-tab) {
  display: flex;
  flex: 1;
}

.cat-c-tabs--full-width .cat-c-tabs__header .cat-c-tabs__list {
  width: 100%;
}

::slotted(cat-tab) {
  display: block;
  flex-shrink: 0;
  padding: 0;
}
.cat-c-tabs-span-container ::slotted(cat-tab) {
  z-index: 1;
  position: relative;
}

.cat-c-tabs--responsive-full-width ::slotted(cat-tab) {
  /**
   * Tabs list within responsive full width tabs
   * 1) Make the tabs list expand full width on small screens
   */
}
@media all and (max-width: 35rem) {
  .cat-c-tabs--responsive-full-width ::slotted(cat-tab) {
    display: flex;
    flex: 1;
  }
}

/**
 * 1) List of selectable triggers that shows that trigger's relatable content when selected
 */
/**
 * Tabs header
 */
.cat-c-tabs__header {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /**
   * 1) Tabs inner where the beginning of the tabs list isn't fully in the viewport
   */
  /**
   * 1) Tabs inner where the end of the tabs list isn't fully in the viewport
   */
  /**
   * Tabs header within responsive full width tabs not start
   */
  /**
   * Tabs header within responsive full width tabs not end
   */
}
.cat-c-tabs:not(.cat-is-start) .cat-c-tabs__header {
  /**
   * Left overflow gradient for the overflow list
   */
}
.cat-c-tabs:not(.cat-is-start) .cat-c-tabs__header:before {
  content: "";
  display: block;
  position: absolute;
  pointer-events: none;
  background: linear-gradient(var(--rtlGradientToRight, 90deg), var(--cat-theme-color-background-default), rgba(255, 255, 255, 0.001) 30%);
  height: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  width: calc(var(--size-base-unit) * 6);
  z-index: var(--cat-z-index-100);
}
.cat-c-tabs:not(.cat-is-end) .cat-c-tabs__header {
  /**
   * Right overflow gradient for the tabs list
   */
}
.cat-c-tabs:not(.cat-is-end) .cat-c-tabs__header:after {
  content: "";
  display: block;
  position: absolute;
  pointer-events: none;
  background: linear-gradient(var(--rtlGradientToRight, 90deg), rgba(255, 255, 255, 0.001) 30%, var(--cat-theme-color-background-default));
  height: 100%;
  inset-block-start: 0;
  inset-inline-end: 0;
  width: calc(var(--size-base-unit) * 6);
  z-index: var(--cat-z-index-100);
}
@media all and (max-width: 35rem) {
  .cat-c-tabs--responsive-full-width:not(.cat-is-start) .cat-c-tabs__header {
    /**
     * Left overflow gradient for the tabs list within responsive full width variant
     * 1) Remove the shadows when the list is full width
     */
  }
  .cat-c-tabs--responsive-full-width:not(.cat-is-start) .cat-c-tabs__header:before {
    content: none;
  }
}
@media all and (max-width: 35rem) {
  .cat-c-tabs--responsive-full-width:not(.cat-is-end) .cat-c-tabs__header {
    /**
     * Right overflow gradient for the tabs list within responsive full width variant
     * 1) Remove the shadows when the list is full width
     */
  }
  .cat-c-tabs--responsive-full-width:not(.cat-is-end) .cat-c-tabs__header:after {
    content: none; /* 1 */
  }
}
@media all and (min-width: 35rem) {
  .cat-c-tabs__header {
    flex-direction: row;
    align-items: baseline;
  }
}

/**
 * Tabs list
 */
.cat-c-tabs__list {
  display: flex;
  overflow: auto;
  width: 100%;
  margin: calc(var(--size-base-unit) * 0.25) 0 var(--cat-space-medium) calc(var(--size-base-unit) * 0.25);
  position: relative;
  order: 2;
  /**
   * Tabs list within contrast control tabs
   */
  /**
   * Order 1 to place tabs after container after actual tabs on medium and large screens
   */
}
.cat-c-tabs--contrast .cat-c-tabs__list {
  width: fit-content;
  margin: 0;
  border-radius: var(--cat-border-radius-xl);
  background: var(--cat-theme-color-background-subtle);
  padding: calc(var(--size-base-unit) * 0.25);
}
@media all and (min-width: 35rem) {
  .cat-c-tabs__list {
    order: 1; /* 1 */
  }
}
.cat-c-tabs-span-container .cat-c-tabs__list:after {
  content: "";
  position: absolute;
  inset-block-end: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 1px;
  border-block-end: 1px solid var(--cat-theme-color-border-default);
}

/**
 * Tabs after
 * 1) Container that sits next to tabs on medium and large screens
 */
.cat-c-tabs__after {
  order: 1;
  margin-block-end: var(--cat-space-medium);
}
@media all and (min-width: 35rem) {
  .cat-c-tabs__after {
    order: 2;
    margin-inline-start: var(--cat-space-medium);
  }
}

/**
 * Tabs list item that is disabled
 */
.cat-c-tabs__item.cat-is-disabled {
  cursor: not-allowed;
}

/**
 * Tabs body
 * 1) Where the tabs panel sits
 */
.cat-c-tabs__body {
  text-align: start;
}

/**
* In Mobile view set width 100% so that tab list will occupy available width
*/
@media all and (max-width: 35rem) {
  .cat-c-tabs--responsive-full-width .cat-c-tabs__list {
    width: 100%;
  }
}

.cat-c-tabs:not(.cat-c-tabs--contrast) ::slotted(cat-tab:focus-visible) {
  border-radius: var(--cat-border-radius-none);
}

.cat-c-tabs ::slotted(cat-tab:focus-visible) {
  border-radius: var(--cat-border-radius-xl);
}
`;
       